exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-4611aa20] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.div-wrapper[data-v-4611aa20] {\n  text-align: left;\n}\n.page-description[data-v-4611aa20] {\n  font-size: 14px;\n  line-height: 130%;\n  color: #979da5;\n  margin-top: 16px;\n  width: 477px;\n}\n.collaborators-container[data-v-4611aa20] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 32px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n", ""]);

// exports
